import { render, staticRenderFns } from "./SurplusTreatyTransRpt.vue?vue&type=template&id=70c27d6b&"
import script from "./SurplusTreatyTransRpt.vue?vue&type=script&lang=js&"
export * from "./SurplusTreatyTransRpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports